//------------------------------------------------------------------------------
// name: feedback.ts
// author: mudas
// created: 2025/12/22
//------------------------------------------------------------------------------

import { FastApiAxiosInstance } from 'common/service/axiosInstances';
import {
  FeedbackDetail,
  FeedbackListItem,
  FeedbackListParams,
  FeedbackResolveParams,
  FeedbackTypeConfig,
  IPaginationParams,
  PaginationResult,
} from 'common/types';

export const getFeedbackTypeConfig = () => {
  return FastApiAxiosInstance.get<FeedbackTypeConfig>('/api/v1/backend/feedback/typeList');
};

export const getFeedbackList = (params: IPaginationParams<FeedbackListParams>) => {
  return FastApiAxiosInstance.get<PaginationResult<FeedbackListItem>>('/api/v1/backend/feedback/list', { params });
};

export const getFeedbackDetail = (params: { feedbackId: number }) => {
  return FastApiAxiosInstance.get<FeedbackDetail>('/api/v1/backend/feedback/detail', { params });
};

// 设置置顶权重
export const resolveFeedback = (params: FeedbackResolveParams) => {
  return FastApiAxiosInstance.post('/api/v1/backend/feedback/process', params);
};
